import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import ReactGA from 'react-ga';

import StoreWrapper from '../../../StoreWrapper';

const PrivateRoute = ({
  blockedByPayment,
  isAuthenticated = false,
  ssoUrl,
  component: Component,
  ...rest
}) => {
  const goToSsoUrl = () => {
    window.location = ssoUrl;
  };

  const renderComponent = (props) => {
    if (blockedByPayment && window.location.pathname !== '/onboarding') {
      window.location.href = '/onboarding';

      return;
    }

    if (isAuthenticated) {
      return (
        <StoreWrapper>
          <Component {...props} />
        </StoreWrapper>
      );
    }

    if (ssoUrl) {
      return goToSsoUrl();
    }
  };

  const render = (props) => renderComponent(props);

  ReactGA.pageview(window.location.pathname + window.location.search);

  return (
    <Route
      {...rest}
      render={render}
    />
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool,
  ssoUrl: PropTypes.string,
  customerStripePaid: PropTypes.bool,
  blockedByPayment: PropTypes.bool,
};

export default PrivateRoute;
